import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import { Button, Checkbox, Icon } from "@haldor/ui";
import { translate as getTranslate } from "@haldor/ui";
import { useSelector, useDispatch } from "react-redux";
import { Expandable } from "UI";
import DropDownList from "./DropDownList";
import { clearScheduleFilter, UpdateFilter } from "actions/ScheduleFilter";
var getLengthOfObject = function getLengthOfObject(object) {
  var filterByTrue = Object.values(object).filter(function (item) {
    return item === true;
  }).length;
  return filterByTrue;
};
var getActivityLength = function getActivityLength(data) {
  var totalLength = data === null || data === void 0 ? void 0 : data.length;
  data.forEach(function (element) {
    var _element$subMenu;
    element.subMenu ? totalLength += (_element$subMenu = element.subMenu) === null || _element$subMenu === void 0 ? void 0 : _element$subMenu.length : totalLength += 0;
  });
  return totalLength;
};
var CalenderHeader = function CalenderHeader(props) {
  var _loggedInUser;
  var overview = props.overview,
    toggleButtons = props.toggleButtons,
    goBack = props.goBack,
    toggleIcon = props.toggleIcon,
    toggleForm = props.toggleForm,
    isToday = props.isToday,
    goToday = props.goToday,
    goForward = props.goForward,
    scheduleLoading = props.scheduleLoading;
  var dispatch = useDispatch();
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  var ScheduleFilter = useSelector(function (state) {
    return state.ScheduleFilter;
  });
  var _useState = useState([{
      id: "Lesson",
      value: "Lessons"
    }, {
      id: "Assignment",
      value: "Assignments",
      subMenu: []
    }, {
      id: "CalendarEvent",
      value: "Calendar events",
      subMenu: []
    }, {
      id: "Meeting",
      value: "Meetings",
      subMenu: []
    }]),
    _useState2 = _slicedToArray(_useState, 1),
    activty = _useState2[0];

  //fetch search group sections
  var handleActivity = function handleActivity(checked, name, groups, parentId) {
    var obj = {};
    if (parentId) {
      obj = _defineProperty(_defineProperty({}, parentId, false), name, checked);
    } else {
      obj = _defineProperty({}, name, checked);
    }
    dispatch(UpdateFilter(false, obj));
  };
  var handleAllSub = function handleAllSub(checked, data, name, allButton) {
    var obj = {};
    if (checked) {
      for (var i = 0; i < data.length; i++) {
        obj[data[i].id] = true;
      }
      if (!allButton) {
        obj[name] = true;
      }
    } else {
      for (var _i = 0; _i < data.length; _i++) {
        obj[data[_i].id] = false;
      }
      if (!allButton) {
        obj[name] = false;
      }
    }
    if (allButton) {
      return obj;
    }
    dispatch(UpdateFilter(false, obj));
  };
  useEffect(function () {
    // Check the 'all activities' box if all boxes are checked		
    var count = getLengthOfObject(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter);
    var max = getActivityLength(activty);
    if (count === max) {
      dispatch(UpdateFilter(true, ScheduleFilter.activitiesFilter));
    }
  }, [ScheduleFilter.activitiesFilter]);

  //check if store is empty and set all to true
  useEffect(function () {
    if (Object.keys(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter).length === 0) {
      allActivites(true, activty);
    }
  }, [activty]);
  var allActivites = function allActivites(checked, arrName, groups) {
    if (checked) {
      var obj = {};
      for (var i = 0; i < arrName.length; i++) {
        if (groups) {
          obj[arrName[i].title] = true;
        } else {
          var _arrName$i$subMenu;
          obj[arrName[i].id] = true;
          if (((_arrName$i$subMenu = arrName[i].subMenu) === null || _arrName$i$subMenu === void 0 ? void 0 : _arrName$i$subMenu.length) > 0) {
            var sub = arrName[i].subMenu;
            var subValues = handleAllSub(true, sub, 0, true);
            obj = _objectSpread(_objectSpread({}, obj), subValues);
          }
        }
      }
      dispatch(UpdateFilter(true, obj));
      return;
    }
    dispatch(clearScheduleFilter());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "calenderToolBar"
  }, overview ? /*#__PURE__*/React.createElement(Icon, {
    name: "Calendar"
  }) : null, overview ? /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: "1.45rem"
    }
  }, translate("schedule-header-overview")) : null, toggleButtons(), /*#__PURE__*/React.createElement("div", {
    className: "navigation-buttons-container"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    style: {
      marginLeft: 0,
      marginRight: "0.5em"
    },
    onClick: goBack,
    disabled: scheduleLoading
  }, toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    disabled: isToday || scheduleLoading,
    style: {
      marginRight: "0.5em",
      marginLeft: 0
    },
    onClick: goToday
  }, translate('Today')), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    style: {
      marginLeft: 0
    },
    onClick: goForward,
    disabled: scheduleLoading
  }, toggleIcon(true), "\xA0"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "1rem"
    }
  }, overview && !((_loggedInUser = loggedInUser) !== null && _loggedInUser !== void 0 && _loggedInUser.isStudent()) ? /*#__PURE__*/React.createElement(Button, {
    onClick: toggleForm,
    type: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Plus"
  }), " ", translate("Create")) : null)), props.hasAdvancedCalendar ? /*#__PURE__*/React.createElement("div", {
    className: "filtering "
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-activties"
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-headline"
  }, translate("Select activities")), /*#__PURE__*/React.createElement(DropDownList, {
    label: "".concat(translate("Displaying"), " ").concat(getLengthOfObject(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter), " ").concat(translate("of"), " ").concat(getActivityLength(activty))
  }, /*#__PURE__*/React.createElement(Checkbox, {
    value: ScheduleFilter.allFilter,
    onChange: function onChange(value) {
      return allActivites(value, activty);
    },
    label: translate('Select all')
  }), /*#__PURE__*/React.createElement("ul", {
    className: "filterModal"
  }, activty.map(function (item) {
    var _item$subMenu;
    return ((_item$subMenu = item.subMenu) === null || _item$subMenu === void 0 ? void 0 : _item$subMenu.length) > 0 ? /*#__PURE__*/React.createElement(Expandable, {
      key: item.id,
      contentStyles: {
        padding: 0
      },
      contentStylesClosed: {
        padding: "0"
      },
      headerStyles: {
        border: "none"
      },
      title: /*#__PURE__*/React.createElement(Checkbox, {
        value: ScheduleFilter.activitiesFilter[item.id],
        onChange: function onChange(value) {
          return handleAllSub(value, item.subMenu, item.id);
        },
        label: translate(item.value)
      })
    }) : /*#__PURE__*/React.createElement(Checkbox, {
      key: item.id,
      value: ScheduleFilter.activitiesFilter[item.id],
      onChange: function onChange(value) {
        return handleActivity(value, item.id);
      },
      label: translate(item.value)
    });
  }))))) : null);
};
export default CalenderHeader;